import React from 'react'
import { Link } from 'react-router-dom'
import Profile_Av from "../../../assets/images/lg/avatar1.jpg"

const Lockscreen = () => {
    return (
        <div className="flex justify-center">
            <div className="sm:p-7 p-3 text-wrap w-full bg-white border rounded auth-body">
                <form>
                    <ul className="grid gap-4 list-none li_animate">
                        <li className="col-span-12 mb-3">
                            <div className="flex items-center">
                                <img
                                    className="rounded-lg shadow-lg sm:w-16 w-10 sm:h-16 h-10 object-cover"
                                    src={Profile_Av}
                                    alt="Avatar"
                                />
                                <div className="ml-3">
                                    <Link className="text-xl text-accent font-semibold" to="/" title="">
                                        Michelle Hughes
                                    </Link>
                                    <p className="mb-0 text-gray-600">michelle.hughes@gmail.com</p>
                                </div>
                            </div>
                        </li>
                        <li className="col-span-12">
                            <div className="mb-2">
                                <label htmlFor='enterpassword' className="block text-lg font-medium text-gray-700 mb-2">Enter Password</label>
                                <input
                                    type="password"
                                    className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                    placeholder="***************"
                                    id='enterpassword'
                                />
                            </div>
                        </li>
                        <li className="col-span-12 my-4">
                            <Link
                                className="block w-full py-3 bg-blue-600 text-white text-center text-base rounded-lg uppercase hover:bg-primary-900 transition"
                                to="/"
                                title=""
                            >
                                Sign In
                            </Link>
                        </li>
                        <li className="col-span-12 text-center">
                            <span className="text-gray-500">
                                Don’t have an account yet?  <Link className="text-accent" to="/signup">
                                    Sign up here
                                </Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>

    )
}

export default Lockscreen